import pixXml from 'pixl-xml';

class ResponseParser {
   /**
    *
    * @param {*} xmlData
    */
   static parseLoginResponse(xmlData) {
      var parser, xmlDoc;
      let response = {};
      parser = new DOMParser();
      xmlDoc = parser.parseFromString(xmlData, 'text/xml');
      let responseCode = parseInt(
         xmlDoc.getElementsByTagName('responsecode')[0].childNodes[0].nodeValue
      );
      let responseDesc = xmlDoc.getElementsByTagName('responsedesc')[0].childNodes[0].nodeValue;
      if (responseCode === 1) {
         let username = xmlDoc.getElementsByTagName('username')[0].childNodes[0].nodeValue;
         let vendorAccountBalance = xmlDoc.getElementsByTagName('vendoraccountbalance')[0]
            .childNodes[0].nodeValue;
         let vendorMsisdn = xmlDoc.getElementsByTagName('vendormsisdn')[0].childNodes[0].nodeValue;
         let referenceId = xmlDoc.getElementsByTagName('referenceid')[0].childNodes[0].nodeValue;
         let vendorAccountStatus = parseInt(
            xmlDoc.getElementsByTagName('vendoraccountstatus')[0].childNodes[0].nodeValue
         );
         response = {
            responseCode,
            responseDesc,
            username,
            referenceId,
            vendorMsisdn,
            vendorAccountBalance,
            vendorAccountStatus,
         };
      } else {
         response = { responseCode, responseDesc };
      }
      return response;
   }
   /**
    *
    * @param {*} xmlData
    */
   static parseValidateResponse(xmlData) {
      var parser, xmlDoc;
      let response = {};
      parser = new DOMParser();
      xmlDoc = parser.parseFromString(xmlData, 'text/xml');

      let responseCode = parseInt(
         xmlDoc.getElementsByTagName('responsecode')[0].childNodes[0].nodeValue
      );
      if (responseCode === 1) {
         let responseDesc = xmlDoc.getElementsByTagName('responsedesc')[0].childNodes[0].nodeValue;
         let referenceId = xmlDoc.getElementsByTagName('referenceid')[0].childNodes[0].nodeValue;
         let transactionId = xmlDoc.getElementsByTagName('transactionid')[0].childNodes[0]
            .nodeValue;
         let firstName = '';
         let lastName = '';

         if (xmlDoc.getElementsByTagName('firstname').length > 0) {
            firstName = xmlDoc.getElementsByTagName('firstname')[0].childNodes[0].nodeValue;
         }
         if (xmlDoc.getElementsByTagName('lastname').length > 0) {
            lastName = xmlDoc.getElementsByTagName('lastname')[0].childNodes[0].nodeValue;
         }

         let meterNumber = xmlDoc.getElementsByTagName('meternumber')[0].childNodes[0].nodeValue;
         let minAmountValue = xmlDoc.getElementsByTagName('minamount')[0].childNodes[0].nodeValue;
         let maxAmountValue = xmlDoc.getElementsByTagName('maxamount')[0].childNodes[0].nodeValue;
         let minAmount = parseInt(minAmountValue.replace(/,/g, ''));
         let maxAmount = parseInt(maxAmountValue.replace(/,/g, ''));
         response = {
            responseCode,
            responseDesc,
            referenceId,
            transactionId,
            firstName,
            lastName,
            meterNumber,
            minAmount,
            maxAmount,
         };
      } else {
         let responseDesc = xmlDoc.getElementsByTagName('responsedesc')[0].childNodes[0].nodeValue;
         response = {
            responseCode,
            responseDesc,
         };
      }
      return response;
   }
   /**
    *
    * @param {*} xmlData
    */
   static parseVendResponse(xmlData) {
      var parser, xmlDoc;
      let response = {};
      parser = new DOMParser();
      xmlDoc = parser.parseFromString(xmlData, 'text/xml');
      let responseCode = parseInt(
         xmlDoc.getElementsByTagName('responsecode')[0].childNodes[0].nodeValue
      );
      if (responseCode === 1) {
         let responseDesc = xmlDoc.getElementsByTagName('responsedesc')[0].childNodes[0].nodeValue;
         let referenceId = xmlDoc.getElementsByTagName('referenceid')[0].childNodes[0].nodeValue;
         let transactionId = xmlDoc.getElementsByTagName('transactionid')[0].childNodes[0]
            .nodeValue;
         let firstName = '';
         let lastName = '';
         if (xmlDoc.getElementsByTagName('firstname').length > 0) {
            firstName = xmlDoc.getElementsByTagName('firstname')[0].childNodes[0].nodeValue;
         }
         if (xmlDoc.getElementsByTagName('lastname').length > 0) {
            lastName = xmlDoc.getElementsByTagName('lastname')[0].childNodes[0].nodeValue;
         }
         let meterNumber = xmlDoc.getElementsByTagName('meternumber')[0].childNodes[0].nodeValue;
         let token = xmlDoc.getElementsByTagName('token')[0].childNodes[0].nodeValue;
         let purchaseAmount = parseInt(
            xmlDoc.getElementsByTagName('purchaseamount')[0].childNodes[0].nodeValue
         );
         let units = parseFloat(xmlDoc.getElementsByTagName('units')[0].childNodes[0].nodeValue);
         let tarrifName = xmlDoc.getElementsByTagName('tariffname')[0].childNodes[0].nodeValue;
         let tariffInfo = xmlDoc.getElementsByTagName('tariffinfo')[0].childNodes[0].nodeValue;
         let receipt = xmlDoc.getElementsByTagName('receipt')[0].childNodes[0].nodeValue;
         response = {
            responseCode,
            responseDesc,
            referenceId,
            transactionId,
            firstName,
            lastName,
            meterNumber,
            token,
            units,
            purchaseAmount,
            tarrifName,
            tariffInfo,
            receipt,
         };
      } else {
         let responseDesc = xmlDoc.getElementsByTagName('responsedesc')[0].childNodes[0].nodeValue;
         response = {
            responseCode,
            responseDesc,
         };
      }
      return response;
   }
   static parseSaleSummaryResponse(xmlData) {
      var parser, xmlDoc;
      let response = {};
      parser = new DOMParser();
      xmlDoc = parser.parseFromString(xmlData, 'text/xml');
      let responseCode = parseInt(
         xmlDoc.getElementsByTagName('responsecode')[0].childNodes[0].nodeValue
      );
      let responseDesc = xmlDoc.getElementsByTagName('responsedesc')[0].childNodes[0].nodeValue;
      if (responseCode === 1) {
         let vendorNames,
            totalSalesCount,
            totalSalesAmount,
            vendorAccountBalance,
            refillThresholdBalance;

         if (xmlDoc.getElementsByTagName('salestransactioncount').length > 0) {
            let totalSalesCountText = xmlDoc.getElementsByTagName('salestransactioncount')[0]
               .childNodes[0].nodeValue;
            totalSalesCount = parseInt(totalSalesCountText.replace(/,/g, ''));
         }

         if (xmlDoc.getElementsByTagName('salestransactioncount').length > 0) {
            let totalSalesCountText = xmlDoc.getElementsByTagName('salestransactioncount')[0]
               .childNodes[0].nodeValue;
            totalSalesCount = parseInt(totalSalesCountText.replace(/,/g, ''));
         }
         if (xmlDoc.getElementsByTagName('vendorname').length > 0) {
            vendorNames = xmlDoc.getElementsByTagName('vendorname')[0].childNodes[0].nodeValue;
         }

         if (xmlDoc.getElementsByTagName('salestransactiontotal').length > 0) {
            let totalSalesAmountText = xmlDoc.getElementsByTagName('salestransactiontotal')[0]
               .childNodes[0].nodeValue;
            totalSalesAmount = parseInt(totalSalesAmountText.replace(/,/g, ''));
         }
         if (xmlDoc.getElementsByTagName('vendoraccountbalance').length > 0) {
            let vendorAccountBalanceText = xmlDoc.getElementsByTagName('vendoraccountbalance')[0]
               .childNodes[0].nodeValue;
            vendorAccountBalance = parseInt(vendorAccountBalanceText.replace(/,/g, ''));
         }
         if (xmlDoc.getElementsByTagName('refillthresholdbalance').length > 0) {
            let refillThresholdBalanceText = xmlDoc.getElementsByTagName(
               'refillthresholdbalance'
            )[0].childNodes[0].nodeValue;
            refillThresholdBalance = parseInt(refillThresholdBalanceText.replace(/,/g, ''));
         }
         let products = [];

         if (xmlDoc.getElementsByTagName('products').length > 0) {
            let productList = xmlDoc.getElementsByTagName('products')[0];
            for (let i = 0; i < productList.childNodes.length; i++) {
               let productId = productList.childNodes[i].childNodes[0].childNodes[0].nodeValue;
               let productName = productList.childNodes[i].childNodes[1].childNodes[0].nodeValue;
               products.push({ productId, productName });
            }
            console.log(products);
         }
         let favorites = [];
         if (xmlDoc.getElementsByTagName('favorites').length > 0) {
            let favoriteList = xmlDoc.getElementsByTagName('favorites')[0];

            for (let i = 0; i < favoriteList.childNodes.length; i++) {
               let product = {};
               let productList = favoriteList.childNodes[i].getElementsByTagName('product');
               for (let j = 0; j < productList.length; j++) {
                  let productId = productList[j].getElementsByTagName('id')[0].childNodes[0]
                     .nodeValue;
                  let productName = productList[j].getElementsByTagName('name')[0].childNodes[0]
                     .nodeValue;
                  product = { productId, productName };
               }
               let buyerIdentifier = favoriteList.childNodes[i].getElementsByTagName(
                  'buyeridentifier'
               )[0].childNodes[0].nodeValue;
               let buyerName = favoriteList.childNodes[i].getElementsByTagName('buyername')[0]
                  .childNodes[0].nodeValue;
               favorites.push({ buyerIdentifier, buyerName, product });
            }
         }

         response = {
            responseCode,
            responseDesc,
            vendorNames,
            totalSalesCount,
            totalSalesAmount,
            vendorAccountBalance,
            refillThresholdBalance,
            products,
            favorites,
         };
      } else {
         response = {
            responseCode,
            responseDesc,
         };
      }
      return response;
   }
   /**
    *
    * @param {*} xmlData
    */
   static parseSaleHistoryResponse(xmlData) {
      let response = {};
      let doc = pixXml.parse(xmlData);
      let salesHistory = [];
      if (Object.keys(doc.sales).length > 0) {
         if (!Array.isArray(doc.sales.salerecord)) {
            salesHistory.push(doc.sales.salerecord);
         } else {
            salesHistory = doc.sales.salerecord;
         }
      }
      response = {
         responseCode: doc.responsecode,
         responseDesc: doc.responsedesc,
         referenceId: doc.referenceid,
         salesHistory,
      };
      return response;
   }

   static parseSendEmailResponse(xmlData) {
      let response = {};
      let doc = pixXml.parse(xmlData);
      console.log(doc);
      response = {
         responseCode: doc.responsecode,
         responseDesc: doc.responsedesc,
         referenceId: doc.referenceid,
         transactionId: doc.transactionid,
      };
      return response;
   }

   static parseSendSmsResponse(xmlData) {
      let response = {};
      let doc = pixXml.parse(xmlData);
      response = {
         responseCode: doc.responsecode,
         responseDesc: doc.responsedesc,
         referenceId: doc.referenceid,
         transactionId: doc.transactionid,
      };
      return response;
   }

   static parseTokenReceiptResponse(xmlData) {
      let response = {};
      let doc = pixXml.parse(xmlData);
      if (doc.responsecode == 1) {
         response = {
            responseCode: doc.responsecode,
            responseDesc: doc.responsedesc,
            referenceId: doc.referenceid,
            transactionId: doc.receiptrecord.transactionid,
            firstName: doc.receiptrecord.firstname,
            lastName: doc.receiptrecordlastname,
            meterNumber: doc.receiptrecord.meternumber,
            token: doc.receiptrecord.token,
            units: doc.receiptrecord.units,
            purchaseAmount: doc.receiptrecord.purchaseamount,
            receiptTime: doc.receiptrecord.datetime,
            tarrifName: doc.receiptrecord.tariffname,
            tariffInfo: doc.receiptrecord.tariffinfo,
            receiptNumber: doc.receiptrecord.receiptnumber,
            receiptItems: doc.receiptrecord.receiptitems.item,
         };
      } else {
         response = {
            responseCode: doc.responsecode,
            responseDesc: doc.responsedesc,
         };
      }
      return response;
   }
}

export default ResponseParser;
